"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vessel_types_1 = require("./vessel.types");
const vessel_1 = require("services/master-data/vessel");
const contractor_1 = require("services/master-data/contractor");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, vessel_1._getMasterVessel)(dataStates);
    if (response.isError) {
        dispatch({
            type: vessel_types_1.vesselTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
                }),
        };
        dispatch({ type: vessel_types_1.vesselTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => {
    const payload = {
        dataStates,
    };
    dispatch({ type: vessel_types_1.vesselTypes.ON_PAGE_CHANGE, payload });
};
const onClickMutation = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: vessel_types_1.vesselTypes.ON_MUTATION_CLICK, payload });
});
const closeError = () => (dispatch) => {
    dispatch({
        type: vessel_types_1.vesselTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false,
        },
    });
};
const onGetDataContractor = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, contractor_1._getDropdownMasterContractorCoalHauling)();
    const dataContractor = response.data;
    dispatch({ type: vessel_types_1.vesselTypes.SET_DATA_CONTRACTOR, payload: dataContractor });
});
const onSaveDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    let { mutationMode } = payload;
    const response = mutationMode == 'add'
        ? yield (0, vessel_1._createVessel)({
            vessel: (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.vessel_no,
            vessel_capacity: (_b = payload.dataItem) === null || _b === void 0 ? void 0 : _b.vessel_capacity,
            contractor_id: (_d = (_c = payload.dataItem) === null || _c === void 0 ? void 0 : _c.contractor) === null || _d === void 0 ? void 0 : _d.id,
            is_active: (_f = (_e = payload.dataItem) === null || _e === void 0 ? void 0 : _e.is_active) === null || _f === void 0 ? void 0 : _f.value,
        })
        : yield (0, vessel_1._editVessel)({
            id: payload.dataItem.id,
            vessel: (_g = payload.dataItem) === null || _g === void 0 ? void 0 : _g.vessel_no,
            vessel_capacity: (_h = payload.dataItem) === null || _h === void 0 ? void 0 : _h.vessel_capacity,
            contractor_id: (_k = (_j = payload.dataItem) === null || _j === void 0 ? void 0 : _j.contractor) === null || _k === void 0 ? void 0 : _k.id,
            is_active: (_m = (_l = payload.dataItem) === null || _l === void 0 ? void 0 : _l.is_active) === null || _m === void 0 ? void 0 : _m.value,
            modified_date: new Date(),
        });
    const isFailed = response.isError;
    mutationMode = !response.isError ? 'success' : mutationMode;
    const messageError = response.errorMessage;
    if (!isFailed)
        dispatch({ type: vessel_types_1.vesselTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { isFailed, mutationMode, messageError }) });
    else
        dispatch({
            type: vessel_types_1.vesselTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
});
const onDelete = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, vessel_1._deleteVessel)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: vessel_types_1.vesselTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { mutationMode: 'success' }) });
    }
    else {
        dispatch({
            type: vessel_types_1.vesselTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
    }
});
const onFilterChange = (payload) => (dispatch) => {
    dispatch({ type: vessel_types_1.vesselTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = (payload) => (dispatch) => {
    dispatch({ type: vessel_types_1.vesselTypes.ON_SORT_CHANGE, payload });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onGetDataContractor,
    onDelete,
    onFilterChange,
    onSortChange,
    closeError,
};
